module.exports = __webpack_public_path__ + "img/hand-pointer.380d2bc.svg";